import React, { useMemo, useReducer } from 'react'
import { environment } from '@dmi-mch/utils'

import { reducer, StateContext } from '../contexts/module'
import { isOkForHydration } from '@utils'

/**
 * @returns {JSX.Element}
 * @constructor
 */
function ModuleProvider({ children, props }) {
  const { CMSProps, attachments } = props
  const initialState = useMemo(() => ({
    CMSProps,
    onlineShowData: null,
    galleryData: null,
    accountData: null,
    attachments,
    attachmentsInformation: null,
    artworkInformation: null,
    roomsInformation: null,
    videos: null,
    labels: null,
    isRecommendationsTriggered: false
  }), [CMSProps, attachments])

  const [state, dispatch] = useReducer(reducer, initialState)

  useMemo(() => {
    if (isOkForHydration(state, initialState)) {
      environment.isNotPro &&
        // eslint-disable-next-line no-console
        console.error(
          'Attention, the initial state configured here and the one declared in' +
          ' ../contexts/module does not match. Remember to update and to add the explanation of what is, what for, ' +
          'and where is used, inside module context file.'
        )
    }
  }, [initialState, state])

  return (
    <StateContext.Provider value={{ state, dispatch }}>{children}</StateContext.Provider>
  )
}

export default ModuleProvider
